import { Injectable } from '@angular/core';
import { RemoteDataPage } from '@lycoris-nubila/ngx-lycoris';
import { TranslateService } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

import { SendMessageCmd } from 'application/message/command/send-message.cmd';
import { MessageApiPort } from 'application/message/port/message-api.port';
import { ObserveMessagesQuery } from 'application/message/query/observe-messages.query';
import { MarkMessagesReadApiMutation } from 'infrastructure/graphql/messaging/message/mutation/mark-messages-read.mutation';
import { UserSessionPort } from 'user/port/user-session.port';
import { FetchUsersByIdsApiQuery } from 'user/query/fetch-users-by-ids.query';

import { ApiAdapter } from '../../common/api.adpater';
import { MessageOutput } from '../../graphql/messaging/message/model/message.output';
import { SendMessageApiMutation } from '../../graphql/messaging/message/mutation/send-message.mutation';
import { FetchMessageByIdApiQuery } from '../../graphql/messaging/message/query/fetch-message-by-id.query';
import { FetchMessagesByCriteriaApiQuery } from '../../graphql/messaging/message/query/fetch-messages-by-criteria.query';

@Injectable()
export class MessageApiAdapter extends ApiAdapter implements MessageApiPort {
	constructor(
		userSessionPort: UserSessionPort,
		translateService: TranslateService,
		private _sendMessageApiMutation: SendMessageApiMutation,
		private _fetchUsersByIdsApiQuery: FetchUsersByIdsApiQuery,
		private _fetchMessageByIdApiQuery: FetchMessageByIdApiQuery,
		private _markMessagesReadApiMutation: MarkMessagesReadApiMutation,
		private _fetchMessagesByCriteriaApiQuery: FetchMessagesByCriteriaApiQuery
	) {
		super(userSessionPort, translateService);
	}

	public fetchMessageById(id: string): Promise<MessageOutput> {
		return this.fetch(this._fetchMessageByIdApiQuery, { id });
	}

	public fetchMessages(
		query: ObserveMessagesQuery
	): Observable<MessageOutput[]> {
		return this.fetch$(this._fetchMessagesByCriteriaApiQuery, {
			input: {
				offset: 0,
				chunkSize: 100,
				authorId: query.authorId,
				participantsId: query.participantsId,
			},
		}).pipe(map((page) => page.elements));
	}

	public markMessagesRead(messagesId: string[]): Promise<MessageOutput[]> {
		return this.mutate(this._markMessagesReadApiMutation, { messagesId });
	}

	public sendMessage(cmd: SendMessageCmd): Promise<MessageOutput> {
		return this.mutate(this._sendMessageApiMutation, {
			input: {
				content: cmd.content,
				documentId: cmd.documentId,
				moduleId: cmd.moduleId,
				visioSessionId: cmd.visioSessionId,
				participantsId: cmd.participantsId,
			},
		});
	}
}
